import { render, staticRenderFns } from "./WebhooksTab.vue?vue&type=template&id=1f9837b4"
import script from "./WebhooksTab.vue?vue&type=script&lang=js"
export * from "./WebhooksTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports